<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px"
        separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>全流程安全生产</el-breadcrumb-item>
        <el-breadcrumb-item>安全制度管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div style="display: flex;justify-content: space-between;">
        <el-button type="primary"
          @click="add()"
          size="small">新建</el-button>
        <div style="display: flex">
        <el-select v-model="status"
          placeholder="状态"
          clearable
          size="small"
          style="margin-right: 10px"
          @change="changeStatus">
          <el-option v-for="item in arr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="safeType"
          placeholder="类别"
          clearable
          size="small"
          style="margin-right: 10px"
          @change="changeStatus">
          <el-option v-for="item in arr2"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <!-- <el-select v-model="status" placeholder="请选择…" clearable size="small"  style="width: 300px">-->
        <!-- <el-option v-for="(item, key) in arr" :label="item.label" :value="item.value">-->
        <!-- </el-option>-->
        <!-- </el-select>-->
        <Input search
          enter-button
          placeholder=" 请输入名称"
          v-model="fileNameOrTag"
          @on-search="getData1(1)"
          style="width: 300px"
        />
      </div>
      </div>
      <div>
        <template>
          <el-table :data="tableData"
            style="width: 100%;margin-top: 15px">
            <el-table-column prop="safeName"
              label="计划名称"></el-table-column>
            <el-table-column prop="safeStatus"
              label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.safeType == 0"
                  style="color: #67C23A;">规章制度</span>
                <span v-if="scope.row.safeType == 1"
                  style="color: #F56C6C;">操作规程</span>
                <span v-if="scope.row.safeType == 2"
                  style="color: #F56C6C;">检查表</span>
              </template>
            </el-table-column>

            <el-table-column prop="starTime"
              label="状态">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.safeStatus == '0'">编制中</el-tag>
                <el-tag v-if="scope.row.safeStatus == '1'"
                  type="success">评审中</el-tag>
                <el-tag v-if="scope.row.safeStatus == '2'">使用中</el-tag>
                <el-tag v-if="scope.row.safeStatus == '3'"
                  type="danger">已作废</el-tag>
                <el-tag v-if="scope.row.safeStatus == '4'"
                  type="warning">待发布</el-tag>
                <el-tag v-if="scope.row.safeStatus == '5'"
                  type="danger">已驳回</el-tag>
              </template>

            </el-table-column>
            <el-table-column prop="endTime"
              label="文件名">
              <template slot-scope="scope">
                <el-link type="primary" @click="downLoad(scope.row)">{{scope.row.safeFileName}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="gmtCreate"
              label="上传时间"></el-table-column>
            <el-table-column prop="reviseTime"
              label="计划修订时间">
              <template slot-scope="scope">
                <!-- <el-tag type="danger">{{scope.row.days}}</el-tag> -->
                {{ scope.row.reviseTime }}
              </template>

            </el-table-column>
            <el-table-column prop="realReviseTime"
              label="实际修订时间"></el-table-column>
            <el-table-column prop="publishName"
              label="发布人"></el-table-column>
            <el-table-column prop="creatorName"
              label="创建人"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-link type="primary"
                  size="small"
                  v-if="scope.row.safeStatus == 0 && myUserId == scope.row.creatorId"
                  @click.native.prevent="submitCheck(scope.row.id , 1)"> 提交审核 &nbsp;</el-link>
                <el-link type="primary"
                  size="small"
                  v-if="scope.row.safeStatus == 1 && myUserId == scope.row.companyId"
                  @click.native.prevent="edit(scope.row ,1)">审核 &nbsp;</el-link>
                <el-link type="primary"
                  size="small"
                  v-if="scope.row.safeStatus == 2 && (myUserId == scope.row.companyId || myUserId == scope.row.creatorId)"
                  @click.native.prevent="edit(scope.row ,2)">修订 &nbsp;</el-link>
                <el-link type="danger"
                  size="small"
                  v-if="scope.row.safeStatus == 2 && (myUserId == scope.row.companyId || myUserId == scope.row.creatorId)"
                  @click.native.prevent="submitCheck(scope.row.id ,3)">作废 &nbsp;</el-link>
                <el-link type="primary"
                  size="small"
                  v-if="scope.row.safeStatus == 3 && (myUserId == scope.row.companyId || myUserId == scope.row.creatorId)"
                  @click.native.prevent="submitCheck(scope.row.id ,2)">启用 &nbsp;</el-link>
                <el-link type="primary"
                  size="small"
                  v-if="scope.row.safeStatus == 4 && myUserId == scope.row.publishId"
                  @click.native.prevent="submitCheck(scope.row.id ,2)">发布 &nbsp;</el-link>
                <el-link type="primary"
                  size="small"
                  v-if="scope.row.safeStatus == 0 && myUserId == scope.row.creatorId"
                  @click.native.prevent="edit(scope.row,0)">编辑 &nbsp;</el-link>
                <el-link type="danger"
                  size="small"
                  @click.native.prevent="del(scope.row.id)"> 删除 </el-link>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right; margin-top: 10px">
            <Page :total="total"
              :page-size="pageSize"
              :current="currentPage"
              @on-change="getData1" />
          </div>
        </template>

      </div>

    </div>

  </div>
</template>

<script>
import { downLoadDocument } from '@/api/downLoad'
export default {
  data() {
    return {
      radio: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pageTotal: 0,
      tableData: [],
      fileNameOrTag: '',
      myUserId: '',
      status: '',
      safeType: '',
      arr: [
        //0_ 编制中，1_ 评审中,2_ 使用中,3_ 已作废
        { label: '编制中', value: 0 },
        { label: '评审中', value: 1 },
        { label: '使用中', value: 2 },
        { label: '已作废', value: 3 },
        { label: '待发布', value: 4 },
        { label: '已驳回', value: 5 }
      ],
      arr2: [
        //0_ 规章制度，1_ 操作规程,2_ 检查表
        { label: '规章制度', value: 0 },
        { label: '操作规程', value: 1 },
        { label: '检查表', value: 2 }
      ]
    }
  },
  mounted: function() {
    this.getData1(1)
    this.getMyUserInfo()
  },
  methods: {
    getMyUserInfo() {
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData('urls').userInfo)
        .openLoad()
        .startGet()
        .then(res => {
          this.myUserId = res.body.data.id
        })
    },
    getNowDate() {
      let date = new Date()
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      return y + '-' + m + '-' + d
    },
    DateDiff(sDate1) {
      //sDate1和 sDate2 是2002-12-18格式
      let sDate2 = this.getNowDate()
      var aDate, oDate1, oDate2, iDays
      aDate = sDate1.split('-')
      oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]) //转换为12-18-2002格式
      aDate = sDate2.split('-')
      oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) //把相差的毫秒数转换为天数
      let result = this.tab(sDate1, sDate2)
      if (result == 1) {
        return '剩余' + iDays + '天'
      } else {
        return '逾期' + iDays + '天'
      }
    },
    tab(date1, date2) {
      var oDate1 = new Date(date1)
      var oDate2 = new Date(date2)
      if (oDate1.getTime() > oDate2.getTime()) {
        return 1
      } else {
        return 0
      }
    },
    submitCheck(id, status) {
      let formData = new FormData()
      formData.append('id', id)
      formData.append('status', status)
      this.componentsMoudel.httpRequest
        .getRequestHander('/safety/submitCheck')
        .openLoad()
        .startPost(formData)
        .then(res => {
          this.getData1(1)
        })
    },

    changeStatus(status) {
      this.getData1(1)
    },
    getData1: function(page) {
      this.currentPage = page
      let param = {}
      param.limit = this.pageSize
      param.curPage = page
      param.paramName = this.fileNameOrTag
      param.safeStatus = this.status
      param.safeType = this.safeType
      this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData('urls').getSafety)
        .openLoad()
        .startPost(param)
        .then(res => {
          this.tableData = res.body.data
          // for (var i = 0; i < this.tableData.length; i++) {
          //   var planTime = this.tableData[i].reviseTime
          //   let days = this.DateDiff(planTime)
          //   if (!days) {
          //     days = '剩余0天'
          //   }
          //   this.tableData[i].days = days
          // }
          // this.currentPage = res.body.page;
          this.total = res.body.cum
          this.pageTotal = res.body.pageTotal
        })
    },
    add: function() {
      this.$router.push({
        path: '/processManager/addSafely'
      })
    },
    edit: function(row, status) {
      this.$router.push({
        name: 'addSafely',
        params: { key: row, status: status }
      })
      // this.$router.push({
      //     name: "addNewEmp",
      //     params: {key: row},
      // });
    },
    del: function(id) {
      this.$confirm('删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.componentsMoudel.httpRequest
            .getRequestHander('/safety/delete/' + id)
            .openLoad()
            .startPost()
            .then(res => {
              if (this.tableData.length <= 1 && this.currentPage > 1) {
                this.currentPage -= 1
              }
              this.getData1(this.currentPage)
              this.$message({
                showClose: true,
                message: '删除成功',
                type: 'success'
              })
            })
        })
        .catch(() => {
          return
        })
    },

    // 下载文件
    downLoad(row) {
      // axios({
      //     method: 'get',
      //     url: this.host + row.safeUrl,
      //     responseType: 'blob'
      // }).then((res) => {
      //     if ('download' in document.createElement('a')) {
      //         let url = window.URL.createObjectURL(res.data);
      //         let link = document.createElement('a');
      //         link.style.display = 'none';
      //         link.href = url;
      //         link.setAttribute('download', row.safeFileName);
      //         document.body.appendChild(link);
      //         link.click();
      //         document.body.removeChild(link);
      //     } else {
      //         navigator.msSaveBlob(res.data, row.safeFileName)
      //     }
      // }).catch(err => {
      //     this.$Message.error(err)
      // })
      downLoadDocument(row.safeUrl, row.safeFileName)
    }
  },
  created() {}
}
</script>

<style scoped>
.head {
  
}

.content {
  background-color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #e9eef3;
}
</style>
